import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import React, { useCallback, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { decimalInvertedReportFormatter } from "../../fomatters/DecimalFormatter";
import Report from "../Report";
import SubGroup from "../SubGroup";

const currentDate = new Date();
currentDate.setMonth(currentDate.getMonth() - 1);

const today = new Date().toISOString().split("T")[0];

/**
 * TABLE FREEPLAYOFFICEOPTIONS
 */
function DistributionDetails() {
  const [week, setWeek] = useState(today);
  const onWeekChange = useCallback((event) => setWeek(event.target.value), []);

  const [agentFrom, setAgentFrom] = useState("");
  const onAgentFromChange = useCallback(
    (event) => setAgentFrom(event.target.value),
    []
  );

  const [agentTo, setAgentTo] = useState("");
  const onAgenToChange = useCallback(
    (event) => setAgentTo(event.target.value),
    []
  );

  const [distributor, setDistributor] = useState("");
  const onDistributorChanged = useCallback(
    (event) => setDistributor(event.target.value),
    []
  );

  const [noActionAgent, setNoActionAgent] = useState(false);
  const onNoActionAgentChange = useCallback(
    (event) => setNoActionAgent(event.target.checked),
    []
  );

  const [orderBy, setOrderBy] = useState(0);
  const onOrderByChange = useCallback(
    (event) => setOrderBy(Number(event.target.value)),
    []
  );

  return (
    <div className="flex flex-col gap-4 p-4 h-max">
      <div className="grid grid-cols-2 gap-4">
        <TextField
          required
          variant="outlined"
          label="Week Of"
          type="date"
          value={week}
          size="small"
          onChange={onWeekChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Distributor"
          type="text"
          value={distributor}
          size="small"
          onChange={onDistributorChanged}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent From"
          type="text"
          value={agentFrom}
          size="small"
          onChange={onAgentFromChange}
          InputLabelProps={{ shrink: true }}
        />
        <TextField
          required
          variant="outlined"
          label="Agent To"
          type="text"
          value={agentTo}
          size="small"
          onChange={onAgenToChange}
          InputLabelProps={{ shrink: true }}
        />
        <div className="col-span-2">
          <FormControlLabel
            control={
              <Checkbox
                size="small"
                checked={noActionAgent}
                onChange={onNoActionAgentChange}
                color="primary"
              />
            }
            label="Include No Action Agents"
          />
        </div>
        <div>
          <SubGroup title="Order By">
            <FormControl component="fieldset">
              <RadioGroup label value={orderBy} onChange={onOrderByChange} row>
                <FormControlLabel
                  control={<Radio value={0} size="small" color="primary" />}
                  label="Distributor"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={1} size="small" color="primary" />}
                  label="Group"
                  labelPlacement="end"
                />
                <FormControlLabel
                  control={<Radio value={2} size="small" color="primary" />}
                  label="Alphabetically"
                  labelPlacement="end"
                />
              </RadioGroup>
            </FormControl>
          </SubGroup>
        </div>
      </div>
      <Report
        title="Distribution Details Report"
        getUrl={() => "/Reports/Report_DistributionDefault"}
        getParams={({ userId }) => ({
          IdUser: Number(userId),
          DateWeek: week,
          Distributor: distributor,
          AgentFrom: agentFrom,
          AgentTo: agentTo,
          NoActionAgent: noActionAgent,
          OrderBy: orderBy,
        })}
        getProcess={(data) =>
          data.map((item) => {
            const comm = item.commSports + item.commHorses + item.commCasino;
            const distWeek =
              item.toDistSports + item.toDistHorses + item.toDistCasino;

            return {
              ...item,
              comm,
              distWeek,
              distributor: item.distributor ?? "<house>",
            };
          })
        }
        getTotals={(data) => ({
          agent: "Totals",
          makeUp: data.reduce((acc, item) => acc + item.makeUp, 0),
          weeklySports: data.reduce((acc, item) => acc + item.weeklySports, 0),
          weeklyCasino: data.reduce((acc, item) => acc + item.weeklyCasino, 0),
          weeklyHorses: data.reduce((acc, item) => acc + item.weeklyHorses, 0),
          commSports: data.reduce((acc, item) => acc + item.commSports, 0),
          commCasino: data.reduce((acc, item) => acc + item.commCasino, 0),
          commHorses: data.reduce((acc, item) => acc + item.commHorses, 0),
          toDistSports: data.reduce((acc, item) => acc + item.toDistSports, 0),
          toDistCasino: data.reduce((acc, item) => acc + item.toDistCasino, 0),
          toDistHorses: data.reduce((acc, item) => acc + item.toDistHorses, 0),
          pBalance: data.reduce((acc, item) => acc + item.pBalance, 0),
          nBalance: data.reduce((acc, item) => acc + item.nBalance, 0),
        })}
        getGlobalTotals={(data) => ({
          weeklySports: "Gross",
          weeklyHorses: data.reduce(
            (acc, item) =>
              acc + item.weeklySports + item.weeklyCasino + item.weeklyHorses,
            0
          ),
          commSports: "Comm",
          commHorses: data.reduce(
            (acc, item) =>
              acc + item.commSports + item.commCasino + item.commHorses,
            0
          ),
          toDistSports: "Dist Wk",
          toDistHorses: data.reduce(
            (acc, item) =>
              acc + item.toDistSports + item.toDistCasino + item.toDistHorses,
            0
          ),
        })}
      >
        <TableHeaderColumn dataSort dataField="Id" isKey hidden>
          Id
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agent">
          Agent
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="makeUp"
          dataFormat={decimalInvertedReportFormatter}
        >
          Make Up
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="weeklySports"
          dataFormat={decimalInvertedReportFormatter}
        >
          Gross Sport
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="weeklyCasino"
          dataFormat={decimalInvertedReportFormatter}
        >
          Gross Casino
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="weeklyHorses"
          dataFormat={decimalInvertedReportFormatter}
        >
          Gross Horse
        </TableHeaderColumn>
        <TableHeaderColumn dataSort dataField="agentType">
          Agent Type
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="commSports"
          dataFormat={decimalInvertedReportFormatter}
        >
          Comm Sport
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="commCasino"
          dataFormat={decimalInvertedReportFormatter}
        >
          Comm Casino
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="commHorses"
          dataFormat={decimalInvertedReportFormatter}
        >
          Comm Horse
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="toDistSports"
          dataFormat={decimalInvertedReportFormatter}
        >
          Dist Wk Sport
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="toDistCasino"
          dataFormat={decimalInvertedReportFormatter}
        >
          Dist Wk Casino
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="toDistHorses"
          dataFormat={decimalInvertedReportFormatter}
        >
          Dist Wk Horse
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="pBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          Prev Balance
        </TableHeaderColumn>
        <TableHeaderColumn
          dataSort
          dataField="nBalance"
          dataFormat={decimalInvertedReportFormatter}
        >
          New Balance
        </TableHeaderColumn>
      </Report>
    </div>
  );
}

export default DistributionDetails;
